import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { NylasConnectionStatusDto, SaveSchedulerConfigDto, SchedulerConfigDto, SchedulerConfigListDto } from '../model';

class NylasCalendarManageConnectionModalClient extends BaseClient {
  getNylasConnectionStatus(): AxiosPromise<NylasConnectionStatusDto> {
    return this.request({
      url: `${hosts.notificationsApi}/email/oauth/status/`,
      method: 'GET',
    });
  }

  getSchedulerConfigs(): AxiosPromise<SchedulerConfigListDto> {
    return this.request({
      url: `${hosts.notificationsApi}/calendar/scheduler-configs/`,
      method: 'GET',
    });
  }

  saveSchedulerConfig(payload: SaveSchedulerConfigDto): AxiosPromise<SchedulerConfigDto> {
    return this.request({
      url: `${hosts.notificationsApi}/calendar/scheduler-config/`,
      method: 'POST',
      data: payload,
    });
  }

  getNylasOauthUrl(): AxiosPromise<string> {
    return this.request({
      url: `${hosts.notificationsApi}/email/oauth/url`,
      method: 'GET',
    });
  }
}

export const nylasCalendarManageConnectionModalClient = new NylasCalendarManageConnectionModalClient();
